<script setup lang="ts">
import { currentBrand } from "@/brand";

/**
 * Logo de la marque dans l'en-tête sombre de l'outil dessin : toujours blanc
 * (le bleu de la charte disparaîtrait sur le fond). Pas de lien : sortir de
 * l'outil passe par le menu fichier, qui propose d'enregistrer.
 */
</script>

<template>
  <span
    v-if="currentBrand.id === 'inspexio'"
    class="canvas-brand-mark"
    aria-hidden="true"
  />
  <span v-else class="canvas-brand-text" aria-hidden="true">DR</span>
</template>

<style lang="scss" scoped>
// Même technique que DRLogo : le tracé en masque, la couleur en CSS.
.canvas-brand-mark {
  display: block;
  flex-shrink: 0;
  height: 18px;
  aspect-ratio: 1211 / 1373; // dimensions du tracé de la charte
  background-color: #fff;
  -webkit-mask: url("/brand/inspexio/mark.svg") center / contain no-repeat;
  mask: url("/brand/inspexio/mark.svg") center / contain no-repeat;
}

.canvas-brand-text {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  color: #fff;
}
</style>
